import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {IReportTypeTableColumn, ReportType} from '../types';

export const getColumns = (): IReportTypeTableColumn[] => [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: ReportType) => <NavLink to={`/report-types/${item.id}`}>{item.name || item.id}</NavLink>,
    },
    {
        title: I18n.get('Version'),
        width: '1fr',
        render: (item: ReportType) => <>{item.version}</>,
    },
    {
        title: I18n.get('Updated'),
        width: '1fr',
        render: (item: ReportType) => <>{formatTimestamp(item.updated as unknown as string)}</>,
    },
];

export const columns = getColumns();
